<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
@font-face {
  font-family: "Dtac2018";
  src: url("./assets/fonts/DTAC2018-Regular.otf") format("opentype");
}
#app {
  font-family: "Dtac2018", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.full-width {
  width: 100%;
}
.dtac-font {
  font-family: "Dtac2018", sans-serif;
}
.is-hoverable {
  cursor: pointer;
}
</style>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$navbar: #057fcb;

$primary: #00aeef;
$primary-invert: findColorInvert($primary);

$warning: #ffdd00;
$warning-invert: findColorInvert($warning);

$danger: #ff0040;
$danger-invert: findColorInvert($danger);

$pink: #ed227c;
$pink-invert: findColorInvert($pink);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "pink": (
    $pink,
    $pink-invert
  )
);

// Nav Bar
$navbar-item-color: #ffffffb4;
$navbar-item-active-color: $white;
$navbar-background-color: $navbar;

$navbar-item-hover-color: $white;
$navbar-item-hover-background-color: $navbar;

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
